<template>
	<div class="main">
		<section class="panel">
            <section class="panel panel-default">
				<header class="panel-heading" style="padding: 10px;">
					<div class="panel-actions" style="top: 7px;">
						<a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
					</div>
					<h4 class="panel-title">查詢條件</h4>
				</header>
				<div id="searchArea" class="panel-collapse collapse in">
					<div class="panel-body">
                        <div class="form-inline">
                            <div class="row form-group">
                                <div class="col-md-12">
                                    <label>學年度</label>
                                    <select v-model="qryParam.year" class="form-control">
                                        <option value="">請選擇</option>
                                        <option v-for="(year, index) in yearList" :key="index" :value="year" >{{year}}</option>
                                    </select>
                                </div>
                            </div>
							<button @click="updateGrid(1)" class="btn s_btn_b">查詢</button>
							<button @click="clearSearchParam" class="btn s_btn_g">清除</button>

                        </div>
					</div>
				</div>
			</section>
			<section class="panel panel-default">
                <div class="tab-content">
                    <div class="tab-pane fade in show" role="tabpanel" aria-labelledby="vacation-tab">
                        <div class="row form-group">
                            <div class="col-md-12 text-right form-inline">
                                <button @click="showEditPopup(true)" class="btn btn-primary">新增費用設定</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <table class="table table-no-more table-bordered table-striped mb-none" >
                                    <thead>
                                        <tr >
                                            <th class="text-center" width="10%">年度</th>
                                            <th class="text-center" width="12.5%">申請等級</th>
                                            <th class="text-center" width="12.5%">申請說明</th>
                                            <th class="text-center" width="12.5%">補助金額</th>
                                            <th class="text-center" width="12.5%">學校支付額</th>
                                            <th class="text-center" width="20%">備註</th>
                                            <th class="text-center" width="10%">修改</th>
                                            <th class="text-center" width="10%">刪除</th>
                                        </tr>
                                    </thead>
                                    <tbody >
                                        <tr v-for="(item, index) in feeList" :key="index">
                                            <td data-title="年度" class="text-center" >{{item.year}}</td>
                                            <td data-title="申請類別" class="text-center" >{{item.applyType}}</td>
                                            <td data-title="申請說明" class="text-center" >{{item.applyDesc}}</td>
                                            <td data-title="補助金額" class="text-center" >{{item.amount}}</td>
                                            <td data-title="學校支付額" class="text-center" >{{item.schAmount}}</td>
                                            <td data-title="備註" class="text-center" >{{item.comment}}</td>
                                            <td data-title="修改" class="text-center" >
                                                <button @click="showEditPopup(true, item.id)" class="btn s_btn_o">修改</button>
                                            </td>
                                            <td data-title="刪除" class="text-center" >
                                                <button @click="handleDelete(item.id)" class="btn btn-primary">刪除</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-md-12">
                                <div class="text-center">
                                    <pageControl :page="page" :total="totalPage"></pageControl>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
			</section>
		</section>
		<editPopup v-if="isShoweditPopup" :id="selectedId"/>
	</div>
</template>
<script>
import editPopup from './editPopup';
export default {
	components:{
		editPopup
	},
	data() {
		return {
			qryParam:{
				year: ""
			},
			feeList: [],
			page: 1,
			totalPage: 1,
			isShoweditPopup: false,
			selectedId: '',
            yearList: []
		};
	},
	mounted() {
        const api = "/api/weakFee/yearList";
        this.$axios.get(api).then(resp => {
            this.yearList = resp.data.data;
            if(this.yearList.length == 0) {
                this.yearList = ['111'];
            }
            if(this.yearList.length > 0 && this.qryParam.year == "") {
                this.qryParam.year = this.yearList[0];
            }
		    this.updateGrid();
        });
	},
	methods: {
		showEditPopup(isOpen, selectedId = '') {
			this.selectedId = selectedId;
			this.isShoweditPopup = isOpen;
			if(!isOpen) {
				this.updateGrid(this.page);
			}
		},
		updateGrid(page = 1){
            this.page = page;

			const api = "/api/weakFee";
			const query = new URLSearchParams({
				year: this.qryParam.year,
				page: this.page,
				pageSize: 10,
			}).toString();
			this.$axios.get(api + '?' + query).then(resp =>{
				this.feeList = resp.data.data.rows;
				this.totalPage = Math.ceil(resp.data.data.rowNum / resp.data.data.pageSize);
				this.page = resp.data.data.page;
			});
		},
		handleDelete(selectId) {
			const _this = this
			bootbox.confirm("是否刪除此筆費用設定", function(result){
				if(result){
					const api = `/api/weakFee/${selectId}`;
					_this.$axios.delete(api).then(resp => {
						if (resp.data.status === "success") {
							bootbox.alert("刪除成功");
							_this.updateGrid(this.page);
						} else {
							bootbox.alert(resp.data.msg);
						}
					});
				}
			});
		},
		clearSearchParam(){
			this.qryParam.year= "";
		},
	},
	computed: {
	}
};
</script>

